import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import deviceIdlePingScheduler from '../../../services/device/deviceIdlePingScheduler';
import deviceIdlePingService from '../../../services/device/deviceIdlePingService';
import {selectFeaturesConfigUpdateDate, selectIsFirmwareStarted} from '../../../state/selectors/iotDevice';
import {makeSelectIsYapDeviceInfoReceived} from '../../../state/selectors/yapEncrypted';

const useDeviceIdlePingSchedulerPause = () => {
    const isYapDeviceInfoReceived = useSelector(makeSelectIsYapDeviceInfoReceived());
    const featuresConfigUpdateDate = useSelector(selectFeaturesConfigUpdateDate);

    // Init scheduler if needed
    useEffect(() => {
        if (!featuresConfigUpdateDate || !isYapDeviceInfoReceived) return;

        const isIdlePingNeeded = deviceIdlePingService.getIsIdlePingNeeded();

        if (!isIdlePingNeeded) return;

        deviceIdlePingScheduler.startScheduler();
    }, [featuresConfigUpdateDate, isYapDeviceInfoReceived]);

    // Pause/unpause scheduler
    const isFirmwareStarted = useSelector(selectIsFirmwareStarted);

    useEffect(() => {
        if (isFirmwareStarted) {
            deviceIdlePingScheduler.pauseScheduler();
        } else {
            deviceIdlePingScheduler.unpauseScheduler();
        }
    }, [isFirmwareStarted]);
};

export default useDeviceIdlePingSchedulerPause;
